import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BACKEND_API_URL } from '../../../utility/api';

export const apiWithAuth = createApi({
  reducerPath: 'apiWithAuth',
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => '/user/profile',
    }), 
  }),
});

export const { useGetProfileQuery } = apiWithAuth;
